"use client";

import { useCartUI } from "./CartUIProvider";

export function CartBackdrop() {
  const { isCartOpen, closeCart } = useCartUI();

  return (
    <div
      className={[
        "fixed inset-0 z-[60] bg-slate-900/45 backdrop-blur-[2px] transition-opacity duration-300",
        isCartOpen ? "opacity-100" : "pointer-events-none opacity-0",
      ].join(" ")}
      onClick={closeCart}
      aria-hidden="true"
    />
  );
}
